import * as React from "react";
import { JsonSerializable } from "../shared/JsonTypes";

export function useLocalStorage<T=JsonSerializable>(
  key: string,
  initialDefault: T
) {
  const [val, setVal] = React.useState<T>(() => {
    const localStorageVal = localStorage.getItem(key);

    return localStorageVal !== null
      ? JSON.parse(localStorageVal)
      : initialDefault;
  });

  React.useEffect(() => {
    if (localStorage.getItem(key) === null) {
      setVal(initialDefault);
    }
  }, [key, initialDefault]);

  React.useEffect(() => {
    localStorage.setItem(key, JSON.stringify(val));
  }, [val, key]);

  return [val, setVal] as [T, React.Dispatch<React.SetStateAction<T>>];
}
